document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-main-nav]');
  if(toggle&&nav) toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});
  document.querySelectorAll('[data-nav-dropdown]').forEach((dropdown)=>{
    const dropdownToggle=dropdown.querySelector('[data-dropdown-toggle]');
    if(!dropdownToggle) return;
    dropdownToggle.addEventListener('click',(event)=>{
      event.preventDefault();
      const open=dropdown.classList.toggle('is-open');
      dropdownToggle.setAttribute('aria-expanded',String(open));
    });
  });
  document.addEventListener('click',(event)=>{
    document.querySelectorAll('[data-nav-dropdown].is-open').forEach((dropdown)=>{
      if(dropdown.contains(event.target)) return;
      dropdown.classList.remove('is-open');
      const dropdownToggle=dropdown.querySelector('[data-dropdown-toggle]');
      if(dropdownToggle) dropdownToggle.setAttribute('aria-expanded','false');
    });
  });
  document.addEventListener('shopify:section:load',()=>document.documentElement.classList.remove('no-js'));
});
